import { Divider, VStack } from "@chakra-ui/layout";

export default function DoubleDivider({ my = 0 }: { my?: number }) {
    return (
        <VStack my={my}>
            <Divider />
            <Divider bg={"HighlightText"} my={-1.5} />
            <Divider />
        </VStack>
    );
}